import { render } from "./NavComponent.vue?vue&type=template&id=04e906ea&scoped=true&ts=true"
import script from "./NavComponent.vue?vue&type=script&lang=ts"
export * from "./NavComponent.vue?vue&type=script&lang=ts"

import "./NavComponent.vue?vue&type=style&index=0&id=04e906ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e906ea"]])

export default __exports__